import useAddress from '@/containers/SubscriptionFormPageNew/Components/Address/useAddress'
import { FormControl } from 'baseui/form-control'
import getError from '@/containers/SubscriptionFormPage/getError'
import SDInput from '@/shared/components/SDComponentsNewDesign/SDInput/SDInput'

const Zipcode = () => {
  const { t, updateAddress, errors, zipcode, showAddressFields } = useAddress()

  if (!showAddressFields) {
    return null
  }

  return (
    <FormControl error={getError('zipcode', errors)}>
      <SDInput
        label={t('subscriptionForm:address_module.zipcode')}
        onBlur={zipcode => updateAddress({ zipcode })}
        currentValue={zipcode}
      />
    </FormControl>
  )
}

export default Zipcode
